import { render, staticRenderFns } from "./FileCleanup.vue?vue&type=template&id=5bd7d4c2&"
import script from "./FileCleanup.vue?vue&type=script&lang=js&"
export * from "./FileCleanup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports